import { Refresh } from '@mui/icons-material';
import { IconButton, PopperPlacementType, Tooltip, useTheme } from '@mui/material';
import { AssetsPageObjectModel } from '@/poms/assetsPageObjectModel';

export const RefreshContents = ({
  onRefresh,
  tooltipPlacement,
}: {
  onRefresh?: () => void;
  tooltipPlacement?: PopperPlacementType;
}) => {
  const theme = useTheme();
  return (
    <Tooltip title='Refresh' placement={tooltipPlacement}>
      <IconButton
        size='small'
        onClick={onRefresh}
        data-testid={AssetsPageObjectModel.RefreshContentsButton}
        sx={{
          marginLeft: 'auto',
          color: theme.palette.text.primary,
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        }}
      >
        <Refresh fontSize='small' />
      </IconButton>
    </Tooltip>
  );
};
